// extracted by mini-css-extract-plugin
export default {"setManageButtons":"DetailsFieldsSetPage_setManageButtons__xoXl-"};